/* @flow */
import React, { Component } from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';
import { responsiveStyles } from '../../constants/Responsive';
import type { ResponsiveValue } from '../../constants/Responsive';
import {
  RESPONSIVE_FONT_SIZE_STYLES,
  RESPONSIVE_TEXT_ALIGN_STYLES,
} from '../../constants/ResponsiveText';

const FONT_SIZE_STYLES = {
  size11: css`
    font-size: 11px;
  `,
  size12: css`
    font-size: 12px;
  `,
  size13: css`
    font-size: 13px;
  `,
  size14: css`
    font-size: 14px;
  `,
  size15: css`
    font-size: 15px;
  `,
  size16: css`
    font-size: 16px;
  `,
  size17: css`
    font-size: 17px;
  `,
  size18: css`
    font-size: 18px;
  `,
  size20: css`
    font-size: 20px;
  `,
  size22: css`
    font-size: 22px;
  `,
  size24: css`
    font-size: 24px;
  `,
  size26: css`
    font-size: 26px;
  `,
  size28: css`
    font-size: 28px;
  `,
  size32: css`
    font-size: 32px;
  `,
};

const FONT_WEIGHT_STYLES = {
  light: css`
    font-weight: 400;
  `, // just use book while we don't have light
  medium: css`
    font-weight: 500;
  `,
  book: css`
    font-weight: 400;
  `,
  bold: css`
    font-weight: 700;
  `,
  black: css`
    font-weight: 900;
  `,
};

const TEXT_ALIGN_STYLES = {
  left: css`
    text-align: left;
  `,
  right: css`
    text-align: right;
  `,
  center: css`
    text-align: center;
  `,
  inherit: css`
    text-align: inherit;
  `,
};

export type SupportedFontSize =
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '20'
  | '22'
  | '24'
  | '26'
  | '28'
  | '32';

export type SupportedAlignment = $Keys<typeof TEXT_ALIGN_STYLES>;

class Text extends Component<{
  tag?: string,
  align?: SupportedAlignment | ResponsiveValue<SupportedAlignment>,
  weight: $Keys<typeof FONT_WEIGHT_STYLES>,
  children?: any,
  color: ?string,
  size?: SupportedFontSize | ResponsiveValue<SupportedFontSize>,
  style?: any,
  className?: any,
}> {
  static defaultProps: $Shape<$PropertyType<Text, 'props'>> = {
    align: 'inherit',
    color: Colors.GrayAlt1,
    size: '16',
    weight: 'book',
    tag: 'p',
  };

  getStyles() {
    const { size, align, weight } = this.props;

    return [
      FONT_WEIGHT_STYLES[weight],
      typeof size === 'string'
        ? FONT_SIZE_STYLES[`size${size}`]
        : responsiveStyles(size, k => RESPONSIVE_FONT_SIZE_STYLES[k]),
      align &&
        (typeof align === 'string'
          ? TEXT_ALIGN_STYLES[align]
          : responsiveStyles(align, k => RESPONSIVE_TEXT_ALIGN_STYLES[k])),
    ];
  }

  render() {
    const { tag: Tag = 'p', children, className, color, style, ...otherProps } = this.props;
    return (
      <Tag
        className={names(...[...this.getStyles(), className])}
        style={{ color, ...style }}
        {...otherProps}>
        {children}
      </Tag>
    );
  }
}

export default Text;



// WEBPACK FOOTER //
// ./src/ui/components/core/Text.js